<template>
<div>
	<Form :label-width="120" class="mt15" v-if="edit">
		<FormItem label="保险期限：" class="mb5">
			{{info.effectiveDateStart}}&nbsp;&nbsp;&nbsp;至&nbsp;&nbsp;&nbsp;{{info.effectiveDateEnd}}
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
			<a :href="info.policyUrl" v-if="info.policyUrl&&$route.path.indexOf('order-detail')>-1" target="_blank" class="ml10">下载保单</a>
			<a v-if="!info.policyUrl&&$route.path.indexOf('order-detail')>-1" @click="wait" class="ml10">下载保单</a>
		</FormItem>
		<FormItem label="凭证号：" class="mb5">
			{{info.policyVoucherNo}}
		</FormItem>
		<FormItem label="保费：" class="mb5">
			{{info.totalPremium|NumFormat}}元
		</FormItem>
		<FormItem label="保单状态：" class="mb5">
			{{ info.statusDesc }}
		</FormItem>
	</Form>
	<Form :label-width="85" class="mt15" v-if="edit">
		<FormItem class="mb5" label="保单说明：">
			云立方在线项目投保共用一个大保单号，理赔时各小项目使用自己的小保单号即保单右上角的“批单号”或者“保险凭证号”；保险理赔拨打电话400-100-0316转6线
		</FormItem>
	</Form>
	<div class="title">被保险人/受益人信息</div>
	<Form :label-width="170" class="mt15 info">
	    <FormItem label="公司名称：" class="mb5">
	        {{info.subjectName}}
	    </FormItem>
	    <FormItem label="统一社会信用代码：" class="mb5">
	    	{{info.subjectIdNo}}
	    </FormItem>
	</Form>
	<div class="title" v-if="!edit">共同被保险人/受益人</div>
	<Form :label-width="170" class="mt15 info" v-if="!edit">
	    <FormItem label="共同被保险人/受益人：" class="mb5">
			<Input type="text" v-model="info.commonSubjectName" placeholder="通过劳务公司用工/代发工资的请补充劳务公司为共同被保险人" />
	    </FormItem>
	    <FormItem label="统一社会信用代码：" class="mb5">
	    	<Input type="text" v-model="info.commonSubjectIdNo" />
	    </FormItem>
	</Form>
	<div class="title">标的信息</div>
		<Form :label-width="170" class="mt15 info">
			<FormItem label="项目名称：" class="mb5">
				{{info.projectName}}
			</FormItem>
			<FormItem label="项目地址：" class="mb5">
				<Row>
					<Col v-if="edit">
						{{info.projectProvince}}{{info.projectCity}}{{info.projectArea}}
					</Col>
					<Col v-else>
						<Area v-model="info.projectAreaCode" placeholder="请选择省市区" @get-city-str="areaChange"/>
					</Col>
					<Col offset="1">
						{{info.projectAddress}}
					</Col>
				</Row>
			</FormItem>
			<FormItem label="建筑面积(含加建面积)：" class="mb5">
				{{info.coveredArea}}平方米
			</FormItem>
			<FormItem label="工程造价：" class="mb5">
				{{info.projectCost|NumFormat}}元
			</FormItem>
		</Form>
	<div class="title">投保方案</div>
	<template v-if="type=='order'">
		<table class="employerTable" cellspacing="0" cellpadding="0" border="0">
			<thead>
				<tr>
					<th>险种</th>
					<th>保障项目</th>
					<th>保额/限额</th>
					<th colspan="2">免赔约定</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td rowspan="3">雇主责任险C款</td>
					<td>死亡伤残</td>
					<td>50万</td>
					<td colspan="2">-</td>
				</tr>
				<tr>
					<td>医疗费</td>
					<td>5万</td>
					<td colspan="2">赔偿社保范围内的医疗费用，免赔100元后按100%赔付</td>
				</tr>
				<tr>
					<td>误工费</td>
					<td>100元/天</td>
					<td colspan="2">免赔5天，最高赔付180天</td>
				</tr>
				<tr>
					<td colspan="2">保险凭证号：{{info.policyVoucherNo}}</td>
					<td colspan="2">总保费：{{info.totalPremium|NumFormat}}元</td>
					<td>保险期限：{{info.effectiveDateStart}}至{{info.effectiveDateEnd}}</td>
				</tr>
			</tbody>
		</table>
		<div class="agree">
			<p><b>特别约定：</b></p>
			<p>1、同一工程在同一保险期间内，限投保一份，多投保无效；</p>
				<p>2、除高处作业外，其他未取得对应的特种作业证书进行特种作业操作引起的意外事故，保险公司不承担保
			险责任，特种作业定义以《特种作业人员安全技术培训考核管理规定》为准。</p>
			<p>3、本保单下承保员工年龄限制为16-65周岁。</p>
			<p>4、本保单仅承保纯个人家庭住宅的室内装修工程；对商用写字楼、商铺、厅堂馆所及开发商未售出交付的住宅装修的室内装修工程以及其他广告招牌制安、展台搭建、外墙施工、空调安装、电梯安装、钢结构工程、维修整改工程、幕墙工程等其他类型的安装工程不承保任何保险责任。</p>
			<p>5、施工员工从事高处作业时因未系绑安全带导致的保险事故属除外责任。高处作业以《高处作业分级标
			准》（中华人民共和国国家标准GB3608－2008）中的定义为准；</p>
			<p>6、本保单承保的工程项目如出现非法转包行为，保险人不承担保险责任；</p>
			<p>7、除首次紧急治疗情况外，受伤雇员均应在二级或二级以上的公立医院就诊（不包括主要作为诊所、康复、护理、休养、静养、戒酒、戒毒等或类似的医疗机构。受伤雇员在得到紧急治疗情况稳定后应转移至二级或二级以上的公立医院继续就诊。</p>
			<p>8、本保单误工费用以100元/人/天作为标准计算赔偿金额，免赔5天，最长赔付180天。</p>
			<p>9、无其他特别约定；</p>
		</div>
	</template>
	<template v-else>
		<table class="employerTable" cellspacing="0" cellpadding="0" border="0">
			<thead>
				<tr>
					<th width="180">险种</th>
					<th>保障项目</th>
					<th width="120">保额/限额</th>
					<th>免赔约定</th>
					<th width="120">保费</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td rowspan="3">团体意外险</td>
					<td>死亡伤残</td>
					<td>50万</td>
					<td>-</td>
					<td rowspan="3">{{info.eliPremium|NumFormat}}元</td>
				</tr>
				<tr>
					<td>医疗费</td>
					<td>5万</td>
					<td>赔偿社保范围内的医疗费用，免赔100元后按100%赔付</td>
				</tr>
				<tr>
					<td>误工费</td>
					<td>100元/天</td>
					<td>免赔5天，最高赔付180天</td>
				</tr>
				<tr v-if="eariProductCode">
					<td>家装安装工程一切险</td>
					<td>物质损失金额和第三者责任赔偿</td>
					<td>{{showEariProduct}}万</td>
					<td>本保单物质损失保险金额和第三者责任赔偿限额共计{{showEariProduct}}万，其中第三者人身伤亡每次事故医疗赔偿限额不超过10万元。</td>
					<td>{{info.eariPremium|NumFormat}}元</td>
				</tr>
				<tr>
					<td colspan="3">
						保险期限：<b>{{info.effectiveDateStart}}至{{info.effectiveDateEnd}}</b>
						<p class="tip">保险止期以实际工程交付为准，但最长不超过6个月</p>
					</td>
					<td colspan="2"><p style="float: right;margin-right: 30px;">总保费：{{info.totalPremium|NumFormat}}元</p></td>
				</tr>
			</tbody>
		</table>
		<div class="agree">
			<p><b>团体意外险特别约定：</b></p>
			<p>
			1、本保单适用《中路财产保险股份有限公司建筑施工人员团体意外伤害保险条款》，同一工程在同一保险期间内，限投保一份，多投保无效。<br />
			2、本保单下承保员工年龄限制为16-65周岁。<br />
			3、本保单仅承保纯个人家庭住宅的室内装修工程；对商用写字楼、商铺、厅堂馆所及开发商未售出交付的住宅装修的室内装修工程以及其他广告
			招牌制安、展台搭建、外墙施工、空调安装、电梯安装、钢结构工程、维修整改工程、幕墙工程等其他类型的安装工程不承保任何保险责任。<br />
			4、本保单承保的工程项目如出现非法转包行为，保险人不承担保险责任。<br />
			5、施工员工从事高处作业时因未系绑安全带导致的保险事故属除外责任。当坠落高度距离基准面在2米及2米以上时，该项作业即称为高空（高处）作业；
			除高处作业外，其他未取得对应的特种作业证书进行特种作业操作引起的意外事故，保险公司不承担保险责任，特种作业定义以《特种作业人员安全技术
			培训考核管理规定》为准。<br />
			6、除首次紧急治疗情况外，受伤雇员均应在二级或二级以上的公立医院就诊（不包括主要作为诊所、康复、护理、休养、静养、戒酒、戒毒等或类似的医疗机构）。受伤雇员在得到紧急治疗情况稳定后应转移至二级或二级以上的公立医院继续就诊。<br />
			7、本保单住院津贴以100元/人/天作为标准计算赔偿金额，免赔5天，最长赔付180天。<br />
			8、兹经合同双方同意，被保险人必须在知道或应当知道保险事故发生后的48小时内（或保单约定的时间内）向保险人报案，因延迟报案影响保险人查勘、定损的，保险人对于无法核实的部分不承担赔偿责任。<br />
			9、伤残定残采用《人身保险伤残评定标准及代码》（标准编号为JR/T0083-2013）是由原中国保险监督管理委员会发布（保监发〔2014〕6号）并经国家标准化委员会备案的中华人民共和国金融行业标准。</p>
		</div>
		<div class="agree">
			<p><b>安装工程一切险特别约定：</b></p>
			<p>1、本保单适用《中路财产保险股份有限公司安装工程一切险条款》，同一工程在同一保险期间内，限投保一份，多投保无效。<br />
				2、本保单适用工程：室内装修合同造价30/40/50万以内，工程物质损失部分的赔偿限额以保额或工程承包合同造价金额中的低者为准，出险时如保额不足比例
				赔付。<br />
				3、本保单承保项目为云立方签约装饰公司并具有相应营业资质及执照证件的合约项目，不承保个人承包施工业务。承保的工程项目如出现非法转包行为，保险人不承担保险责任。<br />
				4、本保单仅承保纯个人家庭住宅的室内装修工程；对商用写字楼、商铺、厅堂馆所及开发商未售出交付的住宅装修的室内装修工程以及其他广告招牌制安、展台搭建、外墙施工、空调安装、电梯安装、钢结构工程、维修整改工程、幕墙工程等其他类型的安装工程不承保任何保险责任； <br />	
				5、理赔时需提供包括并不限于原装修合同/施工合同、合作协议、施工终止证明、消防或公安事故证明等材料，具体以保险人理赔要求为准。<br />
				6、兹经合同双方同意，被保险人必须在知道或应当知道保险事故发生后的48小时内（或保单约定的时间内）向保险人报案，因延迟报案影响保险人查勘、定损的，保险人对于无法核实的部分不承但保险责任。</p>
		</div>
	</template>
	<div class="title">客户联系信息</div>
	<Form :label-width="150" class="mt15 info">

	    <FormItem label="联系人：" class="mb5">
	    	{{info.contactName}}
	    </FormItem>
	    <FormItem label="联系人电话：" class="mb5">
	    	{{info.contactPhone}}
	    </FormItem>
	    <FormItem label="邮箱：" class="mb5">
	    	{{info.contactEmail}}
	    </FormItem>
		<FormItem label="联系人地址：" class="mb5">
	    	{{info.contactAddress}}
	    </FormItem>
	</Form>
	<div class="title">发票信息：
		<RadioGroup v-model="info.invoiceType" v-if="!edit">
			<Radio label="0">不开发票</Radio>
			<Radio label="1">专票（纸质）</Radio>
			<Radio label="2">普票（电子）</Radio>
		</RadioGroup>
		<span v-else>{{info.invoiceType=='0'||!info.invoiceType?'不开发票':(info.invoiceType=='1'?'专票（纸质）':'普票（电子）')}}</span>
	</div>
	<Form :label-width="150" class="mt15 info" v-if="info.invoiceType&&info.invoiceType!='0'">
	    <FormItem label="公司名称：" class="w600">
	        {{info.invoiceName}}
	    </FormItem>
	    <FormItem label="公司税号：" class="w600">
	        {{info.subjectIdNo}}
	    </FormItem>
		<FormItem label="开户行：" class="w600">
			{{info.invoiceBank}}
	    </FormItem>
	    <FormItem label="银行账号：" class="w600">
			{{info.invoiceAccount}}
	    </FormItem>
	    <FormItem label="公司地址：" class="w600">
			{{info.invoiceAddress}}
	    </FormItem>
	    <FormItem label="联系电话：" class="w600">
			{{info.invoicePhone}}
	    </FormItem>
		<FormItem label="联系电话：" class="w600">
			{{info.invoicePhone}}
	    </FormItem>
		
	</Form>
	<Form :label-width="85" class="mt15" v-if="edit">
		<FormItem class="mb5" label="保单验证：">
			拨打平安客服95511→选择⑤（财产险）→选择②（人工客服），接通后要求查看保单下的批单（向客服提供大保单号11176003901722671944，如果要查批单号，需客服在线转业务经理）→转到业务经理后可以详细询问保单及批单信息
		</FormItem>
	</Form>
	<div class="title" v-if="edit&&info.status=='REFUND'">退保信息：</div>
	<Form v-if="edit&&info.status=='REFUND'" :label-width="150" class="mt15 info">
	    <FormItem label="退保金额：" class="w600">
	        {{info.refundPremium|NumFormat}}元
	    </FormItem>
	    <FormItem label="退保时间：" class="w600">
	        {{info.refundDate}}
	    </FormItem>
		<FormItem label="附件：" class="w600">
			<p v-for="(item,index) in JSON.parse(info.refundFile)" :key="index">
				<a :href="item.url" target="_blank">{{ item.name }}</a>
			</p>
	    </FormItem>
	    <FormItem label="备注：" class="w600">
			{{info.memo}}
	    </FormItem>
	</Form>
</div>
</template>
<script>
import Area from '@/pages/haierProduct/components/common/Area'
export default {
	components:{ Area },
	props:{
		info:Object,
		type:String,
		edit:{
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			// eariProductCode:this.$route.query.eariProductCode||this.info.eariProductCode||''
		}
	},
	computed:{
		eariProductCode () {
			return this.$route.query.eariProductCode||this.info.eariProductCode||''
		},
		showEariProduct () {
			if (this.eariProductCode=='ERECTION_ALL_1') return '30'
			if (this.eariProductCode=='ERECTION_ALL_2') return '40'
			if (this.eariProductCode=='ERECTION_ALL_3') return '50'
		}
	},
	methods:{
		wait () {
			this.$Modal.warning({
				title:'提示',
				content:'您已投保成功，1个工作日后可查看盖章保单',
				okText:'确定',
			})
		},
		// 选择省市区
		areaChange(val){
			this.info.projectProvince=val[0].label
			this.info.projectCity=val[1].label
			this.info.projectArea=val[2].label
			this.info.projectProvinceCode=val[0].value
			this.info.projectCityCode=val[1].value
			this.info.projectAreaCode=val[2].value
		}
	},
}
</script>
<style scoped lang="less">
.mb5{
	margin-bottom: 5px;
}
.agree{
	line-height: 2;
	font-size: 13px;
}
.employerTable{
	width: 100%;
	border-left: 1px solid #dfe6ec;
	border-bottom: 1px solid #dfe6ec;
	font-size: 14px;
	color: #1f2d3d;
	margin: 15px 0;
	th{
		height: 48px;
		background: #eef1f6;
		border-right: 1px solid #dfe6ec;
		padding: 0 10px;
	}
	td{
		border-right: 1px solid #dfe6ec;
		border-top: 1px solid #dfe6ec;
		height: 48px;
		padding-left: 10px;
	}
	.tip{
		font-size: 12px;
		padding-left: 70px;
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerYunLiFang/common/Applicant.vue